import {
  createContext,
  useContext,
  useMemo,
  useCallback,
  useEffect,
  useState,
} from "react";

const STORAGE_KEY = "app-currency";

const allCurrency = [
  { value: "USD", label: "USD — Dollar", icon: "🇺🇸" },
  { value: "HTG", label: "HTG — Gourde", icon: "🇭🇹" },
  { value: "CLP", label: "CLP — Peso chileno", icon: "🇨🇱" },
  { value: "MXN", label: "MXN — Peso mexicano", icon: "🇲🇽" },
  { value: "BRL", label: "BRL — Real Brasileño", icon: "🇧🇷" },
];

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children, defaultValue = "CLP" }) {
  const [value, setValue] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {}
  }, [value]);

  const onChangeCurrency = useCallback((next) => setValue(next), []);

  const currentCurrency = useMemo(
    () => allCurrency.find((c) => c.value === value) || allCurrency[0],
    [value]
  );

  const ctx = useMemo(
    () => ({ allCurrency, currentCurrency, onChangeCurrency }),
    [currentCurrency, onChangeCurrency]
  );

  return (
    <CurrencyContext.Provider value={ctx}>{children}</CurrencyContext.Provider>
  );
}

export default function useCurrencyCurrent() {
  const ctx = useContext(CurrencyContext);
  if (!ctx)
    throw new Error(
      "useCurrencyCurrent must be used within <CurrencyProvider>"
    );
  return ctx;
}
